import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Residence1 from "../assets/residence-1.jpeg";
import Residence2 from "../assets/residence-2.jpeg";
import Residence3 from "../assets/residences-ileya.jpeg";
import "./HighbridgeResidencePage.css";

const HighbridgeResidencePage = () => {
  return (
    <>
      <Navbar />
      <section className="residence-section">
        <div className="residence-grid">
          {/* Image Section */}
          <div className="residence-images">
            <img src={Residence3} alt="Highbridge Residence Alt" />
            <img src={Residence2} alt="Highbridge Residence Alt" />
            <img src={Residence1} alt="Highbridge Residence Alt" />
          </div>

          {/* Details Section */}
          <div className="residence-details">
            <h2>HIGHBRIDGE RESIDENCES</h2>
            <p className="price">
              Starting from <span>NGN 90,000,000</span>
            </p>
            <p className="description">
              Highbridge Residences in Abijo GRA offers elegantly crafted
              duplexes that combine modern living with long-term investment
              value — a smart move for anyone looking to own premium homes with
              high ROI.
            </p>

            <div className="detail-block">
              <h4>Location:</h4>
              <p>Abijo GRA, Lekki-Epe Expressway, Lagos State, Nigeria</p>
            </div>

            <div className="detail-block">
              <h4>Landmarks:</h4>
              <ul>
                <li>Coscharis Motors</li>
                <li>Greenspring School</li>
                <li>Abba’s Heart School</li>
                <li>Novare Shopping Mall</li>
                <li>Caleb British International School</li>
                <li>The Beach</li>
              </ul>
            </div>

            <div className="detail-block">
              <h4>Title:</h4>
              <p>C of O</p>
            </div>

            <div className="detail-block">
              <h4>Features:</h4>
              <ul>
                <li>Good road network</li>
                <li>Perimeter fencing</li>
                <li>Portable water supply</li>
                <li>24/7 security</li>
                <li>Electric street lighting</li>
                <li>Sports arena</li>
              </ul>
            </div>

            <div className="detail-block">
              <h4>Available Prototypes & Prices:</h4>
              <ul>
                <li>
                  4-Bedroom Semi-Detached Duplex + BQ :
                  <strong> NGN 140,000,000</strong>
                </li>
                <li>
                  4-Bedroom Terrace Duplex + BQ :
                  <strong> NGN 130,000,000</strong>
                </li>
                <li>
                  3-Bedroom Semi-Detached Duplex + BQ:
                  <strong> NGN 115,000,000</strong>
                </li>
                <li>
                  3-Bedroom Terrace Duplex + BQ:
                  <strong> NGN 90,000,000</strong>
                </li>
              </ul>
            </div>

            <p className="payment-note">
              Flexible payment plans available. Initial deposit from
              <strong> NGN 5,000,000</strong>
            </p>

            <p className="promo-text">
              Realtor Ileya Giveaway! Sell only 1 unit at Highbridge Residences
              (Abijo GRA) with an initial deposit of ₦10 million and get a ₦2
              million cheque instantly, plus commission. Offer valid until June
              30, 2025.{" "}
            </p>
            <div className="contact-button-container">
              <a
                href="https://wa.me/2349114017478"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-button"
                aria-label="Chat with Highbridge Homes on WhatsApp"
              >
                Chat with Us on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Videos Section */}
      <section className="videos-section">
        <h3>Explore More</h3>
        <p className="explore-description">
          Dive deeper into our projects with exclusive video walkthroughs and
          client testimonials.
        </p>
        <div className="videos-grid">
          <div className="video-card">
            <iframe
              src="https://www.youtube.com/embed/BGmR0AWLY3k"
              title="Highbridge Residences Overview"
              allowFullScreen
            ></iframe>
            <p className="video-title">Highbridge Ileya Giveaway</p>
          </div>
          <div className="video-card">
            <iframe
              src="https://www.youtube.com/embed/_H4KBbSsE3I"
              title="Highbridge Residences Overview"
              allowFullScreen
            ></iframe>
            <p className="video-title">Highbridge Residences Overview</p>
          </div>
          <div className="video-card">
            <iframe
              src="https://www.youtube.com/embed/oEuloAVS0Lg"
              title="Abijo GRA Project Tour"
              allowFullScreen
            ></iframe>
            <p className="video-title">Abijo GRA Project Tour</p>
          </div>
          <div className="video-card">
            <iframe
              src="https://www.youtube.com/embed/Rr1j61H3fqM"
              title="Highbridge Client Testimonial"
              allowFullScreen
            ></iframe>
            <p className="video-title">Highbridge Client Testimonial</p>
          </div>
          <div className="video-card">
            <iframe
              src="https://www.youtube.com/embed/Qus2hCf_aDI"
              title="Inside the Duplex: Highbridge"
              allowFullScreen
            ></iframe>
            <p className="video-title">Inside the Duplex: Highbridge</p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default HighbridgeResidencePage;
